<template>
  <div class="screen-redeem-award wow fadeInUp">
    <div class="header">
      <img src="../../../../assets/imageCompleMisson.png" alt="" />
    </div>
    <div class="award">DANH SÁCH QUÀ</div>
    <v-row gutters dense class="list-award">
      <v-col
        v-for="(item, index) in listAward"
        :key="index"
        cols="6"
        xs="6"
        sm="6"
        md="4"
        lg="3"
      >
        <div class="item-award">
          <img :src="item.image" alt="" />
          <span>{{ item.name }}</span>
          <button @click="redeem(item)">
            {{ item.point }}
            <img src="../../../../assets/startPoint2.svg" alt="" /> Đổi quà
          </button>
        </div>
      </v-col>
    </v-row>
    <DialogAward
      @closeDialog="
        () => {
          dialog = false;
        }
      "
      :item="itemAward"
      v-if="dialog"
    />
  </div>
</template>

<script>
import Award1 from "../../../../assets/award-1.jpg";
import Award2 from "../../../../assets/award-2.jpg";
import Award3 from "../../../../assets/award-3.jpg";
import Award4 from "../../../../assets/award-4.jpg";
import Award5 from "../../../../assets/award-5.jpg";
import Award6 from "../../../../assets/award-6.jpg";
import DialogAward from "./DialogAward.vue";
import { get, call } from "vuex-pathify";
export default {
  data() {
    return {
      dialog: false,
      itemAward: {},
      listAward: [
        {
          name: "Giảm 30k khi đăng ký gói VIP",
          image: Award1,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 10% khi mua sản phẩm Samsung bất kỳ",
          image: Award2,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "01 Vé tham dự sự kiện Ravolution 2023 (VIP)",
          image: Award3,
          point: 40,
          expire: "25/12/2023",
        },
        {
          name: "Đăng ký gói VIP chỉ với 9K dành cho khách hàng lần đầu thanh toán",
          image: Award4,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 99k khi đăng ký gói SPORT bằng ví ZaloPay",
          image: Award6,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 30% khi mua sản phẩm Estee Lauder",
          image: Award5,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Đăng ký gói VIP chỉ với 9K dành cho khách hàng lần đầu thanh toán",
          image: Award4,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 99k khi đăng ký gói SPORT bằng ví ZaloPay",
          image: Award6,
          point: 40,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 30% khi mua sản phẩm Estee Lauder",
          image: Award5,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Đăng ký gói VIP chỉ với 9K dành cho khách hàng lần đầu thanh toán",
          image: Award4,
          point: 40,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 99k khi đăng ký gói SPORT bằng ví ZaloPay",
          image: Award6,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 30% khi mua sản phẩm Estee Lauder",
          image: Award5,
          point: 40,
          expire: "25/12/2023",
        },
        {
          name: "Đăng ký gói VIP chỉ với 9K dành cho khách hàng lần đầu thanh toán",
          image: Award4,
          point: 20,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 99k khi đăng ký gói SPORT bằng ví ZaloPay",
          image: Award6,
          point: 40,
          expire: "25/12/2023",
        },
        {
          name: "Giảm 30% khi mua sản phẩm Estee Lauder",
          image: Award5,
          point: 20,
          expire: "25/12/2023",
        },
      ],
    };
  },
  mounted() {},
  components: {
    DialogAward,
  },
  computed: {
    point: get("showcase/pointAward"),
  },
  methods: {
    redeemAward: call("showcase/redeemAward"),
    redeem(award) {
      if (award.point > this.point) {
        alert("không đủ điểm");
      } else {
        this.itemAward = { ...award };
        this.dialog = true;
        this.redeemAward(award);
      }
    },
  },
};
</script>

<style lang="scss">
@import "./screenredem.scss";
</style>
